import { render, staticRenderFns } from "./HeadItemFour.vue?vue&type=template&id=41127cc1&scoped=true"
import script from "./HeadItemFour.vue?vue&type=script&lang=js"
export * from "./HeadItemFour.vue?vue&type=script&lang=js"
import style0 from "./HeadItemFour.vue?vue&type=style&index=0&id=41127cc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41127cc1",
  null
  
)

export default component.exports